import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=648cf895&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=648cf895&prod&lang=scss&scoped=true"
import style1 from "./MarkdownEditor.vue?vue&type=style&index=1&id=648cf895&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648cf895",
  null
  
)

export default component.exports